module.exports = __webpack_public_path__ + "static/media/FullWin.7740f435.wav";